import {useAppDispatch, useAppSelector} from "../app/store/hooks";
import {setSelectedPreset} from "../app/store/slices/generationSlice";
import {EffectType} from "../shared/types/EffectType";
import {CarouselWidget} from "../widgets/CarouselWidget.tsx";
import {SwiperSlide} from "swiper/react";
import {VideoEffectCard} from "../widgets/VideoEffectCard.tsx";
import {useCallback} from "react";

export const VideoEffects = () => {
    const dispatch = useAppDispatch();
    const videoEffects = useAppSelector((state) => state.presets.videoEffects);


    const handleVideoEffectClick = useCallback((effect: EffectType) => {
        dispatch(setSelectedPreset(effect));
    }, [dispatch])



    return (
        <CarouselWidget
            title="Video" titleType="title" height={'210px'}>
            {videoEffects.map((preset) => (
                <SwiperSlide
                    key={preset.id}
                    style={{
                        width: '110px',
                        height: '190px',
                    }}
                >
                    <VideoEffectCard effect={preset} onClick={() => handleVideoEffectClick(preset)} />
                </SwiperSlide>
            ))}
        </CarouselWidget>
    )
};
